module.exports = __webpack_public_path__ + "img/N220.553c75c8.jpg";